<div class="wrapper overflow" [ngClass]="classes"  [class.test] = "isAdminLayoutType">
    <ng-content></ng-content>
  </div>